module.exports = __webpack_public_path__ + "static/woman-adjusting-bubbles-60b5c34739b9492af70da1ef4c1a8312.png";